const BASE_URL = 'https://lokyis.com';

export const PAGE_META = {
  '/': {
    title: 'Lokyis Ltd | Digital Products and Online Services',
    description: 'Discover ProcoView and Bring One Home — thoughtful, human-centred digital products from Lokyis Ltd.',
  },
  '/privacy': {
    title: 'Privacy Policy | Lokyis Ltd',
    description: 'How Lokyis Ltd handles personal information across its websites and digital products.',
  },
  '/terms': {
    title: 'Terms of Service | Lokyis Ltd',
    description: 'Terms governing Lokyis Ltd websites and digital products.',
  },
  '/refund-policy': {
    title: 'Refund Policy | Lokyis Ltd',
    description: 'Refund and access support information for Lokyis Ltd digital products.',
  },
  '/contact': {
    title: 'Contact Lokyis Ltd',
    description: 'Contact Lokyis Ltd for product, company or support questions.',
  },
  '/website-health-check': {
    title: 'Website Health & Security Check | Lokyis Ltd',
    description: 'A one-off £79 website health and security check for UK small businesses. Understand whether your site is up to date, working properly and giving customers a reliable experience.',
  },
  '/connect': {
    title: 'Connect with Tom Lo | Lokyis Ltd',
    description: 'Save Tom Lo’s contact details, see selected Lokyis work, and enquire about a website or app project.',
  },
  '/radar': {
    title: 'Opportunity Radar | Lokyis Ltd',
    description: 'A rolling technology opportunity radar tracking market signals across 24-hour, 7-day, 30-day and 90-day horizons.',
  },
  notFound: {
    title: 'Page Not Found | Lokyis Ltd',
    description: 'The requested page could not be found.',
  },
};

const upsertMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
};

export const setPageMetadata = ({ title, description }) => {
  const url = `${BASE_URL}${window.location.pathname}`;
  document.title = title;
  upsertMeta('meta[name="description"]', { name: 'description', content: description });
  upsertMeta('meta[property="og:title"]', { property: 'og:title', content: title });
  upsertMeta('meta[property="og:description"]', { property: 'og:description', content: description });
  upsertMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
  upsertMeta('meta[property="og:url"]', { property: 'og:url', content: url });
};
